export default __webpack_public_path__ + "static/media/Pistol_4.9e93cee0.png";